let uploaders = {};
export default class FileUploadService{
  
  static trackUpload(uploader){
    if(!uploader){
      return;
    }

    if(!uploader.files){
      return;
    }

    uploader.files.forEach((file)=>{
      uploaders[file.id] = uploader;
    })
  }

  static getUploader(id){
    return uploaders[id];
  }

  static markFinish(id){
    delete uploaders[id];
  }
}